module.exports = __webpack_public_path__ + "img/ep_service.a64b6be5.svg";